import { customElement } from "lit/decorators.js";

import { BaseSocialButton } from "./base-social-button";

import { appleLogoTemplate } from "../social-logos/apple-logo";

@customElement("apple-login-button")
export class AppleLoginButton extends BaseSocialButton {
  constructor() {
    super();
    this.provider = "apple";
  }

  protected override renderContent() {
    return appleLogoTemplate;
  }
}
